<template>
    <div>
        <section id="home-title" class="font-serif uppercase text-[12vw] xsm:text-[3.6vw] md:text-[3.3vw] h-10vw xsm:h-[5vw] border-black border-t-2 border-b-2 flex flex-row px-2 justify-between">
            <div class="font-semibold text-center">FAPESP 60 anos</div>
            <div class="hidden xsm:inline-block text-center font-light">Ciência, cultura e desenvolvimento</div>
            <div class="text-[1.3vw] text-justify tracking-[0.5vw] md:inline-block hidden leading-[5.2vw]">⬤ ⬤ ⬤ ⬤ ⬤ ⬤</div>
        </section>
        <section id="home-main" class="flex flex-col md:flex-row h-fit md:h-[44rem]">
            <div class="w-full md:w-1/2">
                <video class="h-[44rem] object-cover min-w-full" autoplay muted loop :poster="`${publicPath}static/video/home_final.gif`"></video>
            </div>
            <div class="w-full md:w-1/2 bg-warm-gray p-4 text-left flex flex-col justify-between">
                <div>
                    <p class="uppercase">ANIVERSÁRIO</p>
                    <h1 class="font-serif text-5xl">Celebrando o passado, de olho no futuro</h1>
                </div>

                <div>
                    <p class="font-light text-2xl w-3/4 self-end mb-4">
                        O livro <em>FAPESP 60 anos: Ciência, cultura e desenvolvimento</em> é uma obra organizada em 10 fascículos, que conta a história da Fundação e apresenta sua visão para o futuro da ciência brasileira
                    </p>
                    <router-link to="/fasciculos" class="home-router-black font-bold text-xl">Leia todo o conteúdo do livro aqui</router-link>
                </div>
            </div>
        </section>
        <section id="home-fasciculos" class="px-4 py-4 text-left border-black border-t-2 border-b-2">
            <h2 class="font-serif font-medium text-4xl">Fascículos</h2>
            <p class="text-lg mb-2">Disponíveis para leitura online e download</p>
            <div class="flex flex-row">
                <div class="1080p:hidden flex flex-col justify-center pr-4 -mt-8" :class="issueScroll == 'left' ? 'opacity-20' : 'opacity-100'">
                    <svg width="12" height="34" viewBox="0 0 12 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 0.999999L0.999999 17L11 33" stroke="black" stroke-width="2" />
                    </svg>
                </div>
                <div class="1080p:overflow-hidden overflow-x-scroll 1080p:pb-0 pb-3 flex flex-row" @scroll.passive="onScroll">
                    <ul class="issue-scroll flex flex-row w-full text-center gap-12 pb-2 min-w-[1400px]">
                        <li v-for="(issue, index) in issues" :key="issue.slug" class="w-[calc(10%-2rem)]">
                            <router-link v-if="issue.published" :to="{ name: 'SingleIssueView', params: { slug: issue.slug, issueData: issue } }">
                                <img :src="require(`@/assets/img/fa0${index + 1}/fa0${index + 1}_capa.jpg`)" :alt="`Capa do fascículo ${index + 1}`" />
                            </router-link>
                            <div v-else class="bg-warm-gray h-full pt-4">
                                <p>#{{ index + 1 }}</p>
                                <p>{{ issue.month }} de 2022</p>
                                <p class="font-serif font-semibold mt-4 px-2">{{ issue.title }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="1080p:hidden flex flex-col justify-center pl-4 -mt-8" :class="issueScroll == 'right' ? 'opacity-20' : 'opacity-100'">
                    <svg width="12" height="34" viewBox="0 0 12 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.999999 33L11 17L1 1" stroke="black" stroke-width="2" />
                    </svg>
                </div>
            </div>
        </section>
        <section id="home-patrimonio" class="h-[32rem] flex flex-col-reverse md:flex-row">
            <div class="w-full md:w-6/12 bg-warm-gray text-left flex flex-col justify-between p-4">
                <div>
                    <p class="uppercase">Introdução</p>
                    <router-link to="/apresentacao"> <h2 class="font-serif font-medium text-4xl">FAPESP, um patrimônio da população paulista</h2></router-link>
                </div>
                <router-link to="/apresentacao" class="home-router-black text-lg">Leia o texto completo por Marco Antonio Zago</router-link>
            </div>
            <div class="overflow-hidden" id="img_zago"></div>
        </section>
        <section id="home-muito-prazer" class="h-[32rem] flex flex-col-reverse md:flex-row-reverse border-black border-t-2">
            <div class="w-full md:w-4/12 bg-warm-gray text-left flex flex-col justify-between p-4">
                <div>
                    <p class="uppercase">Introdução</p>
                    <router-link to="/muito-prazer-fapesp"> <h2 class="font-serif font-medium text-4xl">Muito prazer, FAPESP</h2></router-link>
                    <p class="text-lg">Um guia prático para entender a Fundação de Amparo à Pesquisa do Estado de São Paulo</p>
                </div>
                <router-link to="/muito-prazer-fapesp" class="home-router-black text-lg">Conheça a FAPESP</router-link>
            </div>
            <div class="w-full h-[32rem] md:w-8/12 overflow-hidden">
                <img class="w-full h-full object-cover" :src="imageSlide()" :alt="`Galeria de imagens -  Muito prazer, FAPESP`" />
            </div>
        </section>
        <section id="home-linha-tempo" class="h-[32rem] flex flex-col-reverse md:flex-row border-black border-t-2 z-10 border-b-2">
            <div class="w-full md:w-6/12 bg-black text-left flex flex-col justify-between text-offwhite p-4">
                <div>
                    <p class="uppercase">Introdução</p>
                    <router-link to="/linha-do-tempo"><h2 class="font-serif font-medium text-4xl">Linha do tempo</h2></router-link>
                </div>
                <router-link to="/linha-do-tempo" class="home-router-white text-lg">Eventos, programas e pessoas que fizeram a história da FAPESP</router-link>
            </div>
            <div class="overflow-hidden" id="img_lt"></div>
        </section>
        <!-- <section id="home-resumo" class="h-[32rem] flex flex-col-reverse md:flex-row-reverse border-black border-t-2 border-b-2 z-20">
            <div class="w-full md:w-8/12 bg-offwhite text-left flex flex-col justify-between text-black p-4">
                <div>
                    <p class="uppercase">Introdução</p>
                    <router-link to="/resumo-executivo"><h2 class="font-serif font-medium text-4xl">Resumo executivo</h2></router-link>
                    <p class="text-lg">Linha fina</p>
                </div>
                <router-link to="/resumo-executivo" class="home-router-black text-lg">Texto</router-link>
            </div>
            <div class="overflow-hidden bg-warm-gray w-full h-full"></div>
        </section> -->
    </div>
</template>

<script>
export default {
    props: ['issues'],
    data() {
        return {
            publicPath: process.env.BASE_URL,
            imgIndex: 0,
            imgUrl: require('@/assets/img/muito-prazer-fapesp/amazonia-1.jpg'),
            issueScroll: 'left',
        }
    },
    methods: {
        onScroll({ target: { scrollLeft, clientWidth, scrollWidth } }) {
            if (scrollLeft + clientWidth >= scrollWidth) {
                this.issueScroll = 'right'
                console.log('right scroll')
            } else if (scrollLeft <= 1) {
                this.issueScroll = 'left'
            } else {
                this.issueScroll = 'mid'
            }
        },
        imageSlide: function () {
            let imageArray = [
                require('@/assets/img/muito-prazer-fapesp/amazonia-1.jpg'),
                require('@/assets/img/muito-prazer-fapesp/cafe.jpg'),
                require('@/assets/img/muito-prazer-fapesp/1962_Carvalho-Pinto.jpg'),
                require('@/assets/img/muito-prazer-fapesp/coronavirus.jpg'),
                require('@/assets/img/muito-prazer-fapesp/planta.jpg'),
                require('@/assets/img/muito-prazer-fapesp/escavacao.jpg'),
                require('@/assets/img/muito-prazer-fapesp/restauracao.jpg'),
                require('@/assets/img/muito-prazer-fapesp/sirius.jpg'),
            ]

            setTimeout(
                function () {
                    if (this.imgIndex > 6) {
                        this.imgIndex = 0
                    }
                    this.imgIndex += 1
                }.bind(this),
                1500
            )

            let imageUrl = imageArray[this.imgIndex]

            return imageUrl
        },
    },
}
</script>

<style lang="postcss" scoped>
.issue-scroll {
    scrollbar-width: thin;
}
#img_lt {
    background-image: url('@/assets/img/home/fundo-linha-tempo.svg');
    background-size: cover;
    background-position: center;
    @apply w-full h-full;
}
#img_zago {
    background-image: url('@/assets/img/home/zago-horizontal_0.jpg');
    background-size: cover;
    background-position: center;
    @apply w-full h-full;
}
.home-router-black:before {
    background-image: url('@/assets/img/home/seta-pos.svg');
    background-repeat: no-repeat;
    background-size: 1.25rem;
    content: ' ';
    margin-bottom: -0.25rem;
    @apply w-5 h-5 inline-block mr-2;
}
.home-router-white:before {
    background-image: url('@/assets/img/home/seta-neg.svg');
    background-repeat: no-repeat;
    background-size: 1.25rem;
    content: ' ';
    margin-bottom: -0.25rem;
    @apply w-5 h-5 inline-block mr-2;
}
</style>
>
